import { useEffect, useState } from "react";
import { CustomError } from "../http/errors";

const useDataInitializer = <T>(data?: T, error?: CustomError): [T | undefined, boolean] => {
  const [state, setState] = useState<{
    data: T | undefined;
    isInitialized: boolean;
  }>({
    data: data,
    isInitialized: false,
  });

  useEffect(() => {
    setState((prev) => ({
      data: !error ? data ?? prev.data : undefined,
      isInitialized: prev.isInitialized || !data || !error,
    }));
  }, [data, error]);

  return [state.data, state.isInitialized];
};

export default useDataInitializer;
